<template>
  <div class="post">
    <post-header :post="post"/>
    <post-body :text="post.text"/>
    <div class="post-footer">
      <a class="to-original" target="_blank" :href="post.uri">
        Оригинал
      </a>
      <div class="post__date--popular">
        {{ post.created_date }}
      </div>
      <post-repost :post="post.repost" v-if="Object.keys(post.repost).length"/>
      <div class="post-comments" v-if="post.comments !== '0'"></div>
      <div class="post-comments-count">
        <img class="post-comments-count__icon" src="../../../../assets/images/icon-comment.svg" alt="">
        <span class="post-comments-count__count">{{ post.comments }}</span>
        <span class="post-comments-count__show" @click="showCommentsAction">
          {{ showComments ? 'Скрыть' : 'Показать' }}
        </span>
      </div>
      <template v-if="showComments">
        <post-comment v-for="comment in commentaries" :comment="comment" />
        <div class="button-wrap">
          <span class="post-comments-count__show" @click="showComments = !showComments">
            Скрыть
          </span>
          <button class="show-more-comment" v-if="showButton" @click.stop="showCommentsHandler">
            Показать еще
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import PostHeader from './postHeader.vue';
import PostBody from './postBody.vue';
import PostComment from './postComment.vue';
import PostRepost from './postRepost.vue';
import PostReComment from './postReComment.vue';
import { getCommentsApi } from '../../../../api/posts';

export default {
  name: 'post',
  components: {
    PostReComment,
    PostRepost,
    PostComment,
    PostBody,
    PostHeader,
  },
  props: {
    post: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showComments: false,
      showMoreComments: false,
      commentaries: '',
      count: 0,
      start: 0,
      limit: 30,
      showButton: true,
    };
  },
  methods: {
    showCommentsHandler() {
      this.showCommentsAction();
    },
    showCommentsAction() {
      this.showComments = true;
      const params = {
        limit: 30,
        network_id: this.post.network_id,
        owner_id: this.post.owner_id,
        post_id: this.post.id,
        start: this.start,
        thread_id: this.$route.params.id,
      };
      getCommentsApi(params)
        .then((resp) => {
          this.commentaries = [...this.commentaries, ...resp.data.commentaries];
          this.count = this.commentaries.length;

          if (this.count < this.limit || this.count === parseInt(resp.data.count, 10)) {
            this.showButton = false;
          }

          this.start = this.commentaries.length;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.post
  display flex
  flex-direction column
  &-comments
    border-top 1px solid #ccc
    width 100%
    margin-top 1em
    padding 1em 0
    &-count
      display flex
      align-items center
      cursor pointer
      margin-bottom 1em
      &__icon
        width 1.4em
        hieght 1.4em
        margin 0 1em 0 0
      &__show
        display inline-block
        margin-left 1em
        font-weight bold
        color #460303
        cursor pointer
      &__show-more
        display inline-block
        margin-left 1em
        font-weight bold
        color #460303
        cursor pointer
  .post-footer
    display flex
    justify-content flex-end
    align-items center
    .to-original
      margin-right 15px;
      font-size 12px
      color #460303
      text-decoration none
  .button-wrap
    padding 15px
    display flex
    justify-content center
    .show-more-comment
      margin-left 20px
      border none
      outline none
      background-color transparent
      color #460303
      cursor pointer
</style>
